/* eslint-disable unicorn/filename-case -- TODO rename later */
export function getEnv(key: string): string | undefined {
  const windowEnv = (window as { env?: Record<string, string | undefined> }).env;
  if (windowEnv?.[key]) {
    return windowEnv[key];
  }
  return import.meta.env[key];
}
